import type {ZoomVideoSDKDialInNumberType} from './ZoomVideoSdk';

export type ZoomVideoSdkSessionDialInNumberInfoType = {
    /**
     * The country ID.
     */
    countryId: string;

    /**
     * The country code.
     */
    countryCode: string;

    /**
     * The country name.
     */
    countryName: string;

    /**
     * Dial in number.
     */
    number: string;

    /**
     * Dial in number format string for display.
     */
    displayNumber: string;

    /**
     * Get the current item dial in number type.
     */
    type: ZoomVideoSDKDialInNumberType;
};

export class ZoomVideoSdkSessionDialInNumberInfo implements ZoomVideoSdkSessionDialInNumberInfoType {
    countryId;
    countryCode;
    countryName;
    number;
    displayNumber;
    type;

    constructor(sessionDialInNumberInfo: ZoomVideoSdkSessionDialInNumberInfoType) {
        this.countryId = sessionDialInNumberInfo.countryId;
        this.countryCode = sessionDialInNumberInfo.countryCode;
        this.countryName = sessionDialInNumberInfo.countryName;
        this.number = sessionDialInNumberInfo.number;
        this.displayNumber =sessionDialInNumberInfo.displayNumber;
        this.type = sessionDialInNumberInfo.type;
    }
}
